import { AfterViewInit , Component, EventEmitter, Input, Output, ViewChild} from "@angular/core";
import { Order } from "../../../../objects/orders/order";
import { LocationUtil } from "../../../../common/utils/LocationUtil";
import { CurrencyEnum } from "../../../../objects/products/currencyEnum";
import { TaxType } from "../../../../objects/orders/taxType";
import { BaseCalculatorTab } from "../calculatorResults/baseCalculatorTab";
import { CalculatorType } from "../../../../objects/orders/calculatorType";
import { CanadianCurrencyCode } from "../../../../objects/currencyExchange/canadianCurrencyCode";
import { EmailService } from "../../../../services/emailService";
import { OrderService } from "../../../../services/orderService";
import { CalculatorHelper } from "../../../../common/helpers/calculatorHelper";
import { Router } from "@angular/router";
import { OrderStatus } from "../../../../objects/orders/orderStatus";
import { OrderDataComponent } from "../../../Managment/orderManagement/orderData/orderData.component";
import { OrderOptions } from "../../../../objects/orders/orderOptions";
import { EmailTemplateType } from "../../../../objects/email/emailTemplateType";
import { ConfigService } from "../../../../services/configService";
import { ToastsManager } from "ng2-toastr";
import { EmailRequest } from "../../../../objects/email/EmailRequest";
import { WizardComponent } from "ngx-wizard";
import { OrderHelper } from "../../../../common/helpers/orderHelper";
import { TaxHelper } from "../../../../common/helpers/tax.helper";
import { ClearanceFeeCardComponent } from "../../cards/currency-card/clearance-fee-card.component";
import { UploadService } from "../../../../services/uploadService";
import { SelfServeFileType } from "../../../../objects/documents/SelfServeFileType";
import { fromPromise } from "rxjs/observable/fromPromise";
import { BehaviorSubject } from "rxjs/BehaviorSubject";

/**
 * Created by alex.y on 8/10/2017.
 */


@Component({
    selector: "calculator-tab",
    templateUrl: "./calculatorTab.component.html",
    moduleId: module.id.toString()
})
export class CalculatorTabComponent extends BaseCalculatorTab implements AfterViewInit {

    @ViewChild('customsClearanceFee')
    public customsClearanceFee: ClearanceFeeCardComponent;

    @Input()
    public order: Order;

    @Input()
    public wizard: WizardComponent;

    @Input()
    public canadianCurrencyCodes: CanadianCurrencyCode[];

    @Input()
    public disableChanges: boolean;

    @Input()
    public isOrderDetails: boolean;

    @Input()
    public orderDataComp: OrderDataComponent;

    @Input()
    public clonedOrder: Order;

    @Output()
    public orderChange: EventEmitter<Order> = new EventEmitter();

    @Input()
    public isPublic: boolean = false;

    public totalGrand: number = 0;
    public clonedTotalGrand: number = 0;

    public totalPriceBase: number = 0; //Total price of products before convert to currency
    public clonedTotalPriceBase: number = 0;

    public totalPriceInCurrency: number = 0;//Total price of products after convert but without taxes
    public clonedTotalPriceInCurrency: number = 0;

    public totalAACustomsClearanceFee: number = 0; // Total price of BB fee
    public clonedTotalAACustomsClearanceFee: number = 0;
    public percentFee: number = 0;

    public locationUtil = LocationUtil;
    public calculatorHelper = CalculatorHelper;

    public currencyEnum = CurrencyEnum;
    public taxType = TaxType;
    public calculatorType = CalculatorType;

    public isSpinerVisible: boolean = true;
    public paypalDisabled: boolean = false;

    public orderOptions = OrderOptions;
    public orderStatus = OrderStatus;

    public totalPriceDefaultCode: CanadianCurrencyCode;

    public comment: string;
    public isEmailSending: boolean = false;

    private aaFeeCurrencyCode: CanadianCurrencyCode = null;
    public cardRequestLoader: boolean = false;
    public sentText: boolean = false;
    public fileName$: BehaviorSubject<string> = new BehaviorSubject<string>('');
    public isDisableInviteCustomerButton$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    public get isOrderValid(): boolean {
        return this.errorMessages.length == 0;

    }

    public errorMessages: Array<string> = [];

    public constructor(public toastr: ToastsManager, public orderService: OrderService, public router: Router, private emailService: EmailService, private configService: ConfigService,
                       private uploadService: UploadService) {
        super();
    }

    public ngAfterViewInit(): void {
        setTimeout(() => {
            this.validateOrder();
            this.isSpinerVisible = false;
        });

        fromPromise(this.uploadService.getAllFiles(this.order.Id))
            .subscribe((resp) => {
                const b3File = resp.Data.find(i => i.Type === SelfServeFileType.B3Form);

                if (!b3File) {
                    return;
                }
                this.fileName$.next(b3File.Filename);
            });

        this.recalculateTotals();

        if (this.disableChanges)
            this.isSpinerVisible = false;
    }

    public recalculateTotals(): void {
        this.totalPriceDefaultCode = CalculatorHelper.getTotalPriceCurrencyCode(this.order, this.canadianCurrencyCodes);

        this.totalPriceBase = this.onProductsValueChange(this.totalPriceDefaultCode);
        this.totalPriceInCurrency = this.onCustomsValueChange(this.order.Currency);

        this.totalAACustomsClearanceFee = this.recalculateBBClearanceFeeProxy();

        this.totalGrand = this.calculateGrantTotal(this.order.Currency);

        let tempOrder = JSON.parse(JSON.stringify(this.order));
        this.order = JSON.parse(JSON.stringify(this.clonedOrder));

        this.clonedTotalPriceBase = this.onProductsValueChange(this.totalPriceDefaultCode);
        this.clonedTotalPriceInCurrency = this.onCustomsValueChange(this.order.Currency);

        this.clonedTotalAACustomsClearanceFee = this.recalculateBBClearanceFeeProxy();

        this.clonedTotalGrand = this.calculateGrantTotal(this.order.Currency);

        this.order = JSON.parse(JSON.stringify(tempOrder));
    }

    public validateOrder(): void {
        this.errorMessages = [];

        if (!this.order) {
            this.errorMessages.push("Order is empty");

            return;
        }

        if (!this.order.Locations || this.order.Locations.length == 0) {
            this.errorMessages.push("No locations specified for order. Can not calculate totals.");
        }

        if (!this.order.Currency)
            this.errorMessages.push("Currency is not specified for order. Can not calculate.");
    }

    public onProductsValueChange(selectedCode: CanadianCurrencyCode): number {
        if (selectedCode == null)
            return;

        return CalculatorHelper.calculateProductsValue(selectedCode, this.order);
    }

    public handleProductsValueChange(selectedCode: CanadianCurrencyCode, clone: boolean = false): void {
        if (selectedCode == null)
            return;

        this.totalPriceBase = this.onProductsValueChange(selectedCode);

        if (clone)
            this.clonedTotalPriceBase = this.totalPriceBase;
    }

    public onCustomsValueChange(selectedCode: CanadianCurrencyCode): number {
        if (selectedCode == null)
            return;

        return this.calculateCustomsValue(selectedCode);
    }

    public handleCustomsValueChange(selectedCode: CanadianCurrencyCode, clone: boolean = false): void {
        if (selectedCode == null)
            return;

        this.totalPriceInCurrency = this.onCustomsValueChange(selectedCode);

        if (clone)
            this.clonedTotalPriceInCurrency = this.totalPriceInCurrency;
    }

    public handleClearanceFeeChange(param: { selectedCode: CanadianCurrencyCode, clone: boolean }): void {
        if (param.selectedCode == null)
            return;

        this.aaFeeCurrencyCode = param.selectedCode;

        this.totalAACustomsClearanceFee = this.onClearanceFeeChange(param.selectedCode);

        if (param.clone)
            this.clonedTotalAACustomsClearanceFee = this.totalAACustomsClearanceFee;
    }

    public onClearanceFeeChange(selectedCode: CanadianCurrencyCode): number {
        if (selectedCode == null)
            return;

        return this.calculateClearanceFee(selectedCode);
    }

    public onBBClearanceFeeChange(order: Order): void {
        this.order = order;
        this.clonedOrder = JSON.parse(JSON.stringify(this.order));

        this.totalAACustomsClearanceFee = this.recalculateBBClearanceFeeProxy();

        if (OrderHelper.hasOption(this.order, OrderOptions.IsBBFeeEdited))
            this.clonedTotalAACustomsClearanceFee = this.totalAACustomsClearanceFee;

        this.orderChange.emit(order);

        this.totalGrand = this.calculateGrantTotal(this.order.Currency);
        this.clonedTotalGrand = this.totalGrand;
    }

    public calculateBBClearanceFeeForUsa(selectedCode: CanadianCurrencyCode): number {
        if (selectedCode == null)
            selectedCode = this.order.Currency;

        let total: number = 0;

        for (let orderItem of this.order.OrderItems) {
            const aatax = TaxHelper.getItemTaxOrNull(orderItem, TaxType.AAFee);

            if (aatax != null)
                total += (+aatax.Value).roundToDigits(3);
        }

        return total.roundToDigits(3);
    }

    private recalculateBBClearanceFeeProxy(): number {
        return this.recalculateBBClearanceFee([
            { calc: this.calculateBBClearanceFeeForCad, type: CalculatorType.CanadianImport, args: [this.aaFeeCurrencyCode] },
            { calc: this.calculateBBClearanceFeeForUsa, type: CalculatorType.UsaImport, args: [this.aaFeeCurrencyCode] },
            { calc: this.onClearanceFeeChange, type: null, args: [this.order.Currency] },
        ]);
    }

    private recalculateBBClearanceFee(bbCalculators: { calc: (currency: CanadianCurrencyCode) => void, type?: CalculatorType, args: any[] }[]): number {
        const calculatorType = CalculatorHelper.getCalculatorType(this.order.Locations);

        const isEdited = OrderHelper.hasOption(this.order, OrderOptions.IsBBFeeEdited);

        const currentCalculator = bbCalculators.find(x => x.type == (isEdited == false ? null : calculatorType));

        if (currentCalculator == null)
            return 0;

        return currentCalculator.calc.call(this, ...currentCalculator.args);
    }

    public calculateBBClearanceFeeForCad(selectedCode: CanadianCurrencyCode): number {
        let total: number = 0;

        for (let orderItem of this.order.OrderItems) {
            const aatax = TaxHelper.getItemTaxOrNull(orderItem, TaxType.AAFee);

            if (aatax)
                total += aatax.Value.roundToDigits(2);
        }

        return total;
    }

    public async onGrandTotalChange(selectedCode: CanadianCurrencyCode): Promise<void> {
        if (selectedCode == null || this.disableChanges)
            return;

        this.order.Currency = selectedCode;
        this.order.CalculatorType = CalculatorHelper.getCalculatorType(this.order.Locations);

        const isBBFeeEdited = OrderHelper.hasOption(this.order, OrderOptions.IsBBFeeEdited);

        if (!this.isOrderValid)
            return;

        try {
            this.isSpinerVisible = true;

            if (isBBFeeEdited)
                this.customsClearanceFee.convertOrderItemsTax([
                    { converter: this.customsClearanceFee.convertToOriginUsa, type: CalculatorType.UsaImport },
                    { converter: this.customsClearanceFee.convertToOriginCad, type: CalculatorType.CanadianImport }
                ]);

            let resp = await this.orderService.update(this.order);

            this.order = resp.Data;
            this.totalGrand = this.calculateGrantTotal(selectedCode);

            if (isBBFeeEdited) {
                this.recalculateTaxesToSelected(this.order);
                this.totalAACustomsClearanceFee = this.recalculateBBClearanceFeeProxy();
            }

            this.clonedOrder = JSON.parse(JSON.stringify(this.order)); //Clone order for check if smth changed
            this.clonedTotalGrand = this.totalGrand;

            this.clonedTotalPriceBase = this.totalPriceBase;
            this.clonedTotalPriceInCurrency = this.totalPriceInCurrency;
            this.clonedTotalAACustomsClearanceFee = this.totalAACustomsClearanceFee;

            this.order.CalculatorType = CalculatorHelper.getCalculatorType(this.order.Locations);

            this.orderChange.emit(this.order);
        }
        catch (e) {
            const t = e;
        }
        finally {
            this.isSpinerVisible = false;
        }
    }

    public calculateCustomsValue(selectedCode: CanadianCurrencyCode): number {
        let total: number = 0;

        if (selectedCode == null) {
            return total;
        }

        for (let orderItem of this.order.OrderItems) {
            total += orderItem.Price * orderItem.CanadianCurrencyCode.Value; //convert to canadian
        }

        return total / selectedCode.Value;
    }

    public calculateClearanceFee(selectedCode: CanadianCurrencyCode): number {
        let total: number = 0;

        let rate: number = 1;

        if (selectedCode.Code != this.order.Currency.Code) {
            rate = this.order.Currency.Value;
        }

        for (let orderItem of this.order.OrderItems) {
            total += this.findTax(TaxType.AAFee, orderItem).Value * rate;
        }

        if (selectedCode.Code == this.order.Currency.Code) {
            return total;
        }

        return total / selectedCode.Value;
    }

    public calculateGrantTotal(selectedCode: CanadianCurrencyCode): number {
        let total: number = 0;

        for (let orderItem of this.order.OrderItems) {
            total += this.calculateGrantTotalForItem(orderItem, this.order);
        }

        return total;
    }
    //public sendCreditCardRequest(order: Order){

    //    this.cardRequestLoader = true;
    //    let request = new EmailRequest({
    //        EmailType: EmailTemplateType.CreditCardRequest,
    //        OrderId: order.Id
    //    });

    //    this.emailService.sendPaymentEmail(request).then(resp => {

    //        if(resp.Success){
    //            this.cardRequestLoader = false;
    //            this.sentText = true;
    //        }

    //    })
    //}
    public goToOrderDetail(): void {
        this.order.Status = OrderStatus.Quoted;
        this.orderChange.emit(this.order);

        if(OrderHelper.hasOption(this.order, OrderOptions.IsBBFeeEdited))
            this.recalculateTaxes(this.order);

        this.orderService.modify(this.order).then(x => {
            if (!x.Data)
                return;

            document.getElementById('mainPanel').scrollTop = 0;

            this.clonedOrder = JSON.parse(JSON.stringify(this.order));//Clone order for check if smth changed

            this.order = x.Data;
            this.order.CalculatorType = CalculatorHelper.getCalculatorType(this.order.Locations);

            if(OrderHelper.hasOption(this.order, OrderOptions.IsBBFeeEdited))
                this.recalculateTaxesToSelected(this.order);

            this.orderChange.emit(this.order);

            if (this.isOrderDetails == true) {

                setTimeout(() => {
                    this.orderDataComp.selectTab(1);
                    this.wizard.nextTab();
                }, 200);
            }

            else
                this.router.navigate(['order', this.order.Id]);
        })
    }

    public sendOrderToCustomer(orderId: number): void {
        this.isEmailSending = true;

        this.emailService.sendOrderToCustomer(new EmailRequest({ OrderId: orderId, EmailType: EmailTemplateType.OrderToCustomer, Comment: this.comment })).then(x => {
            this.toastr.success("Sending mail succeeded");
            this.comment = "";
            this.isEmailSending = false;
        }).catch(() => {
            this.toastr.error("Sending mail failed");
            this.isEmailSending = false;
        });

    }

    public async createOrder(isOpenPayPal: boolean = false): Promise<void> {
        const googleWindow = window.open(`${window.location.origin}/paymentredirect`);

        try {
            this.paypalDisabled = true;
            let response = await this.orderService.createInvoice(this.order.Id);

            if (isOpenPayPal && response.Data) {
                googleWindow.location.replace(`${this.configService.config.PayPalUrl}/invoice/payerView/details/${response.Data.Invoice.Id}`);
            }
        }
        catch (e) {
            console.log(e);
        }
        finally {
            this.paypalDisabled = false;
        }
    }

    public calculatePercentFee(): number {
        if (this.customsClearanceFee == null || this.customsClearanceFee.currentCurrencyCode == null || String.isNullOrEmpty(this.customsClearanceFee.currentCurrencyCode.Id))
            return 0;

        let firstCardConvertedValue = this.onProductsValueChange(this.customsClearanceFee.currentCurrencyCode);

        if (this.totalPriceBase !== 0)
            return this.totalAACustomsClearanceFee * 100 / firstCardConvertedValue;

        return null;
    }

    public recalculateTaxes(order: Order): void {
        this.order = order;
        // i think i should do it only for non cad/usd currency
        this.customsClearanceFee.convertOrderItemsTaxTest([
            { converter: this.customsClearanceFee.convertToOriginUsa, type: CalculatorType.UsaImport },
            { converter: this.customsClearanceFee.convertToOriginCad, type: CalculatorType.CanadianImport }
        ], this.order);


        this.orderChange.emit(this.order);
    }

    public recalculateTaxesToSelected(order: Order): void {
        this.order = order;
        // i think i should do it only for non cad/usd currency
        this.customsClearanceFee.convertOrderItemsTaxTest([
            { converter: this.customsClearanceFee.convertToSelectedUsd, type: CalculatorType.UsaImport },
            { converter: this.customsClearanceFee.convertToSelectedCad, type: CalculatorType.CanadianImport }
        ], this.order);

        this.orderChange.emit(this.order);
    }

    uploadB3Form(file: File) {
        if (!file) {
            return;
        }

        this.uploadService
            .uploadFile(this.order.Id, SelfServeFileType.B3Form, file)
            .subscribe((resp) => {
                this.fileName$.next(file.name);
                this.toastr.success(`B3 form was successfully added to shipment #${this.order.Id}`);
            });
    }

    public sendInviteCustomerEmail(): void {

        this.isDisableInviteCustomerButton$.next(true);

        this.emailService
            .inviteCustomerToSelfServeApp(this.order.Customer.Email)
            .then( () => {
                this.toastr.success('Invite email was sent');
                this.isDisableInviteCustomerButton$.next(false);
            }, reject => {
                this.toastr.error(reject.Data.Message || reject.Data);
                this.isDisableInviteCustomerButton$.next(false);
            });
    }
}



// WEBPACK FOOTER //
// ./app/components/calculator/tabs/calculator-tab/calculatorTab.component.ts